import Attribute from './Attribute'

export * from './Attribute'

export default Attribute
